module.exports = __webpack_public_path__ + "img/source05_5.03a8323f.png";